module.exports = __webpack_public_path__ + "media/images/features/3/album/main-3-71d40f6715c504ade11d206188c1232c.jpg";